// Core
import React from 'react';
import { useSelector } from 'react-redux';
// Components
import {
  GeckoCardTable,
  GeckoAvatar,
  GeckoCardWrapper,
  GeckoCardBody,
  GeckoCardHeader,
} from 'ui';
import StatsLoader from '../../../components/StatsLoader';
//logic
import StatsLogic from '../../../Logic/StatsLogic';
import GeckoLocation from 'services/gecko-location';
import GeckoPagination from 'services/gecko-pagination';

function AgentsTable(props) {
  const fetchingStats = useSelector(
    (state) => state.statsRoute.fetchingAgentStats
  );

  const getTableCols = () => {
    return [
      {
        key: 'name',
        name: 'Name',
        sortable: 'full_name',
        render: (_name, agent) => {
          return (
            <div>
              <GeckoAvatar
                name={agent.full_name}
                first_name={agent.first_name}
                last_name={agent.last_name}
                color={agent.additional.avatar_colour}
              />
              <span>&nbsp;{agent.full_name}</span>
            </div>
          );
        },
        width: '15%',
      },
      {
        id: 'agents_1',
        key: 'number_messages',
        name: 'Messages Sent',
        description: 'Count of messages sent by the agent.',
        icon: true,
        sortable: true,
        width: '10%',
        render: (value) => (value ? value : 0),
      },
      {
        id: 'agents_2',
        key: 'number_conversations',
        name: 'Agent Conversations Closed',
        description:
          'Count of conversations with status closed where the conversation is assigned to the agent.',
        icon: true,
        sortable: true,
        width: '10%',
        render: (value) => (value ? value : 0),
      },
      {
        id: 'agents_3',
        key: 'median_response_time',
        name: 'Median First Response',
        description: 'The median time to first response in new conversations.',
        icon: true,
        sortable: true,
        width: '10%',
        render: (value) =>
          value ? StatsLogic.getHumanReadableSecondsString(value) : '-',
      },
      {
        id: 'agents_4',
        key: 'median_time_to_close',
        name: 'Median Conversation Length',
        description:
          'The median duration of a closed conversation that the agent was involved in.',
        icon: true,
        sortable: true,
        width: '10%',
        render: (value) =>
          value ? StatsLogic.getHumanReadableSecondsString(value) : '-',
      },
      {
        id: 'agents_5',
        key: 'time_online',
        name: 'Time online',
        description: 'Total time spent online by an agent',
        icon: true,
        sortable: true,
        width: '10%',
        render: (value) =>
          value ? StatsLogic.getHumanReadableSecondsString(value) : '-',
      },
    ];
  };

  const [agentStats, agentPagination] = GeckoPagination.paginate({
    page: props.params.agent_page,
    order_by: props.params.agent_order_by || 'full_name',
    sort: props.params.agent_sort || 'ASC',
    changePage: (newPage = 1) => {
      return GeckoLocation.goTo(
        GeckoLocation.location.pathname,
        Object.assign({}, GeckoLocation.params, { agent_page: newPage })
      );
    },
    changeOrder: (key) => {
      let sort;
      if (
        !GeckoLocation.params.agent_sort ||
        GeckoLocation.params.agent_order_by !== key
      ) {
        sort = 'DESC';
      } else {
        sort = GeckoLocation.params.agent_sort === 'ASC' ? 'DESC' : 'ASC';
      }
      return GeckoLocation.goTo(
        GeckoLocation.location.pathname,
        Object.assign({}, GeckoLocation.params, {
          agent_order_by: key,
          agent_sort: sort,
        })
      );
    },
  })(props.agentStats);

  const iconText = "A summary of each agent's performance";
  const headerIcon = 'fa fa-question-circle';
  const tableName = 'Agent Stats';

  return (
    <div>
      {fetchingStats ? (
        <GeckoCardWrapper>
          <GeckoCardHeader
            iconText={iconText}
            name={tableName}
            icon={headerIcon}
          />
          <GeckoCardBody>
            <StatsLoader isLoading={fetchingStats} />
          </GeckoCardBody>
        </GeckoCardWrapper>
      ) : (
        <GeckoCardTable
          headerProps={{
            iconText,
          }}
          name="Agent Stats"
          headerIcon="fa fa-question-circle"
          cols={getTableCols()}
          rows={agentStats}
          rowHandler={(agent) => GeckoLocation.goTo('/agents/' + agent.id)}
          pagination={agentPagination}
        />
      )}
    </div>
  );
}
export default AgentsTable;
